// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes BackgroundWave{0%{background-position:0 50%}50%{background-position:100% 50%}to{background-position:0 50%}}@keyframes BackgroundWaveHover{0%{background-position:0 50%}50%{background-position:100% 50%}to{background-position:0 50%}}.offerCtaCell{background-size:400% 400%;animation:BackgroundWave 2s ease infinite;background:linear-gradient(138deg,#f8bc00,#f8cd46)}.offerCtaCell:hover{background-size:400% 400%;animation:BackgroundWaveHover 1s ease infinite}", ""]);
// Exports
module.exports = exports;
